import { render, staticRenderFns } from "./ContentCounters.vue?vue&type=template&id=99d8a7e8&scoped=true&"
import script from "./ContentCounters.vue?vue&type=script&lang=js&"
export * from "./ContentCounters.vue?vue&type=script&lang=js&"
import style0 from "./ContentCounters.vue?vue&type=style&index=0&id=99d8a7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d8a7e8",
  null
  
)

export default component.exports